module.exports = __webpack_public_path__ + "img/self_high_five.ac802ad2.webp";